<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('病历档案表')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="downloadWord(record)">下载word</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <patient-medical-records-modal ref="modalForm" @ok="modalFormOk"></patient-medical-records-modal>
  </a-card>
</template>

<script>
  import { httpAction, postAction } from '@api/manage'
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import PatientMedicalRecordsModal from './modules/PatientMedicalRecordsModal'

  export default {
    name: 'PatientMedicalRecordsList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      PatientMedicalRecordsModal
    },
    data () {
      return {
        description: '病历档案表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'预约id',
            align:"center",
            dataIndex: 'makeAppointmentId'
          },
          {
            title:'房间ID',
            align:"center",
            dataIndex: 'roomId'
          },
          {
            title:'患者ID',
            align:"center",
            dataIndex: 'patientId'
          },
          {
            title:'身份证',
            align:"center",
            dataIndex: 'idCard'
          },
          {
            title:'男女',
            align:"center",
            dataIndex: 'sex'
          },
          {
            title:'年龄',
            align:"center",
            dataIndex: 'age'
          },
          {
            title:'上次就诊时间',
            align:"center",
            dataIndex: 'lastTime'
          },
          {
            title:'检查检验单-0，外观照片-1，病历/处方-2，其他-3',
            align:"center",
            dataIndex: 'type'
          },
          {
            title:'其他描述',
            align:"center",
            dataIndex: 'ortherDesc'
          },
          {
            title:'疾病名称',
            align:"center",
            dataIndex: 'diseaseDesc'
          },
          {
            title:'症状描述',
            align:"center",
            dataIndex: 'systomsDesc'
          },
          {
            title:'用药情况',
            align:"center",
            dataIndex: 'medicineDesc'
          },
          {
            title:'状态',
            align:"center",
            dataIndex: 'status'
          },
          {
            title:'医生id',
            align:"center",
            dataIndex: 'doctorId'
          },
          {
            title:'医院检查',
            align:"center",
            dataIndex: 'hosDesc'
          },
          {
            title:'患者姓名',
            align:"center",
            dataIndex: 'patientName'
          },
          {
            title:'患病时长',
            align:"center",
            dataIndex: 'timeLength'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/patientMedicalRecords/patientMedicalRecords/list",
          delete: "/patientMedicalRecords/patientMedicalRecords/delete",
          deleteBatch: "/patientMedicalRecords/patientMedicalRecords/deleteBatch",
          exportXlsUrl: "/patientMedicalRecords/patientMedicalRecords/exportXls",
          importExcelUrl: "patientMedicalRecords/patientMedicalRecords/importExcel",
          downWord:'/patientMedicalRecords/patientMedicalRecords/exportZip'
          
        },
        dictOptions:{},
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      downloadWord(record){
        console.log("123",record)
        var id = record.id
        postAction(this.url.downWord,{id}).then((res)=>{
          if(res.success){
            this.edit (res.result);
          }
        });
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>